import React, { useEffect, useState } from "react";
import axios from "../../../services/axios";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography, Container } from "@mui/material";

import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import DestinoDetails from "./DestinoDetails";
import DestinoMap from "./DestinoMap";
import DestinoVideo from "./DestinoVideo";
import DestinoGaleria from "./DestinoGaleria";

/* 👉 Contenedor responsivo */
const ContentContainer = ({ children }) => (
  <Container
    maxWidth="xl"
    sx={{
      py: { xs: 3, sm: 4, md: 6 },
      px: { xs: 2, sm: 3, md: 6 },
    }}
  >
    {children}
  </Container>
);

const InformacionPage = () => {
  const { id } = useParams();
  const [destino, setDestino] = useState(null);
  const [likes, setLikes] = useState(0);
  const [liked, setLiked] = useState(false);
  const [isLiking, setIsLiking] = useState(false);

  useEffect(() => {
    const fetchDestino = async () => {
      try {
        const response = await axios.get(`/destinos/${id}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });

        const data = response.data;
        setDestino(data);
        setLikes(data.like_count ?? 0);
        setLiked(Boolean(data.userLiked));
      } catch (error) {
        console.error("Error fetching destino", error);
      }
    };

    fetchDestino();
  }, [id]);

  const handleLike = async () => {
    if (isLiking) return;
    setIsLiking(true);

    try {
      const response = await axios.post(
        `/destinos/${id}/like`,
        {},
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      setLikes(Number(response.data.likes));
      setLiked(Boolean(response.data.userLiked));
    } catch (error) {
      console.error("Error dando like:", error);
    } finally {
      setIsLiking(false);
    }
  };

  if (!destino) {
    return (
      <>
        <Header />
        <Box py={6}>
          <Typography align="center">Cargando...</Typography>
        </Box>
      </>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header />

      {/* 🔽 CONTENIDO PRINCIPAL */}
      <Box sx={{ flex: 1 }}>
        <ContentContainer>
          <Grid container spacing={4}>
            {/* 📱 DETALLES */}
            <Grid item xs={12} md={6}>
              <DestinoDetails
                destino={destino}
                likes={likes}
                liked={liked}
                handleLike={handleLike}
                isLiking={isLiking}
              />
            </Grid>

            {/* 🎥 VIDEO */}
            <Grid item xs={12} md={6}>
                <DestinoVideo video={destino.video} />
            </Grid>

            <Grid item xs={12} md={6}>
                <DestinoGaleria
                    imagenes={destino.imagenes}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <DestinoMap destino={destino} />
            </Grid>

            {/* 🗺️ MAPA */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                mb: { xs: 6, md: 0 }, // ✅ separación REAL del footer
              }}
            >

            </Grid>
          </Grid>
        </ContentContainer>
      </Box>

      <Footer />
    </Box>
  );
};

export default InformacionPage;
